import React, { Component } from 'react';
import ToastrService from '@/shared/services/ToastrService';
import handleHttpError from '@/shared/services/HandleHttpError';
import { calcEndOfMonth } from '@/modules/settings/InvoiceSchedules/InvoiceScheduleModal';
import DatePicker from '@/shared/components/input/DatePicker';
import { falseFunc } from '@/shared/utils/validationHelpers';
import messages from './documentMessages';
import api from '../../shared/api';
import config from '../../config';
import OkCancelModal from '../../shared/components/OkCancelModal';

export default class ProcessRegistrationListModal extends Component {
  state = {
    referenceDate: calcEndOfMonth(new Date()),
  };

  handleRegistrationList = () => {
    const { referenceDate } = this.state;
    const { documentId, onSave, intl, stateService } = this.props;
    const model = {
      referenceDate,
      documentId,
    };

    return api.base
      .post(`${config.appUrls.api}/api/documentrecognition/HandleRegistrationList`, model)
      .then(
        ({ data }) => {
          const onClick = data ? () => stateService.gotoJob(data.id) : undefined;
          ToastrService.info(
            intl.formatMessage(messages.ProcessRegistrationListQueued),
            null,
            onClick,
          );
          onSave(data);
        },
        error => {
          handleHttpError(intl)(error);
        },
      );
  };

  render() {
    const { show, onClose, intl } = this.props;
    const { referenceDate, referenceDateFocused } = this.state;

    return (
      <OkCancelModal
        title={intl.formatMessage(messages.ProcessRegistrationList)}
        show={show}
        onClose={onClose}
        onSave={() => this.handleRegistrationList()}
      >
        <div className="row">
          <div className="form-horizontal form-labels-left">
            <div className="form-group">
              <label className="control-label col-sm-6" style={{ paddingLeft: '30px' }}>
                {intl.formatMessage(messages.DefaultRegistrationDate)}
              </label>
              <div className="col-sm-6">
                <DatePicker
                  placeholder={intl.formatMessage(messages.DefaultRegistrationDate)}
                  focused={referenceDateFocused}
                  onFocusChange={({ focused }) => this.setState({ referenceDateFocused: focused })}
                  date={referenceDate}
                  id="referenceDate"
                  block
                  small
                  isOutsideRange={falseFunc}
                  onDateChange={referenceDate => this.setState({ referenceDate })}
                />
              </div>
            </div>
          </div>
        </div>
      </OkCancelModal>
    );
  }
}
